export const DEFAULT_LOADING_REQUEST_ID = 'loading_data';
